/** Words with a tone and size from the type scale. Mono is for small labels, times and numbers only (brand). */
import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './Text.module.css'

export function Text({
  tone = 'default',
  size = 'md',
  mono,
  weight,
  as: As = 'span',
  children,
}: {
  tone?: 'default' | 'muted' | 'faint' | 'accent' | 'down'
  size?: 'xs' | 'sm' | 'base' | 'md'
  mono?: boolean
  weight?: 'read' | 'head'
  as?: 'span' | 'p' | 'div'
  children: ReactNode
}) {
  return <As className={cx(s.text, s[`tone-${tone}`], s[`size-${size}`], mono && s.mono, weight && s[`weight-${weight}`])}>{children}</As>
}

/** A heading. Hierarchy comes from weight and position; sizes stay quiet. */
export function Heading({ level = 2, children }: { level?: 1 | 2 | 3; children: ReactNode }) {
  const H = `h${level}` as const
  return <H className={cx(s.heading, s[`h${level}`])}>{children}</H>
}
